var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { APPEvent } from "@/events/AppEvents";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
export class AdminMainViewerState {
    constructor() {
        this.activepagenumber = 1;
        this.zoomfactor = 0.5;
        this.loadingactivepage = false;
        this.totalpages = 0;
        this.annotate = false;
        this.pagestate = new Map();
        this.sethighlightterms = new Map();
        this.pages = new Map();
        makeObservable(this);
        APPEvent.addSubscriberForPdfFilePage((res) => {
            var _a, _b;
            if (this.pagestate.has(res.pagenumber)) {
                let page = new Uint8Array();
                if (res.page !== undefined) {
                    page = LetrwingCrypto.base64ToBin(res.page);
                }
                (_a = this.pagestate.get((res.pagenumber))) === null || _a === void 0 ? void 0 : _a.setPage(page);
                (_b = this.pagestate.get((res.pagenumber))) === null || _b === void 0 ? void 0 : _b.setPageLoading(false);
            }
        });
    }
    addHightlight(pg, posi) {
        var _a;
        if (!this.sethighlightterms.has(pg)) {
            this.sethighlightterms.set(pg, new Set());
        }
        (_a = this.sethighlightterms.get(pg)) === null || _a === void 0 ? void 0 : _a.add(posi);
    }
    resetHighlight() {
        this.sethighlightterms.clear();
    }
    reset() {
        this.pagestate.clear();
        this.setActivePageNumber(1);
        this.setZoomFactor(0.5);
        this.setTotalPages(1);
    }
    setTotalPages(pages) {
        this.totalpages = pages;
    }
    setLoadingActivePage(loading) {
        this.loadingactivepage = loading;
    }
    setActivePageNumber(num) {
        this.activepagenumber = num;
    }
    cleanup() {
    }
    setActivePageNumberStr(num) {
        this.activepagenumber = num;
    }
    setZoomFactor(fc) {
        this.zoomfactor = fc;
        for (const pgstate of Array.from(this.pagestate.values())) {
            pgstate.setWidth((window.innerWidth - 200) * fc);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMainViewerState.prototype, "activepagenumber", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMainViewerState.prototype, "zoomfactor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMainViewerState.prototype, "loadingactivepage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMainViewerState.prototype, "totalpages", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMainViewerState.prototype, "annotate", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminMainViewerState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMainViewerState.prototype, "setTotalPages", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMainViewerState.prototype, "setLoadingActivePage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMainViewerState.prototype, "setActivePageNumber", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMainViewerState.prototype, "setActivePageNumberStr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMainViewerState.prototype, "setZoomFactor", null);
